import request from './request.js'

export default{
    /* 查询所有地区 */
    getAllAddress() {
      return request({
        url: '/Address/getAllAddress',
        method: 'get',
      });
    },
    /* 查询一级地区（省）*/
    getProvince() {
      return request({
        url: '/Address/GetAllProvinces',
        method: 'get',
      });
    },
    /* 查询二级地区（市）*/
    getCity(params) {
      // 拼接参数：provincesId（string）
      return request({
        url: '/Address/getAllCity' + params,
        method: 'get',
      });
    },
    /* 查询三级地区（县、区）*/
    getArea(params) {
      // 拼接参数：cityId（string）
      return request({
        url: '/Address/getAllArea' + params,
        method: 'get',
      });
    },

    // 查询一级地区是否存在
    judgeExistsProvince(params) {
      // 拼接参数： id 编号（int）  code 省份代码（string）
      return request({
        url: '/Address/ExistsProvinces' + params,
        method: 'get',
      });
    },
    // 查询二级地区是否存在
    judgeExistsCity(params) {
      // 拼接参数： id 编号（int）  code 市代码（string）
      return request({
        url: '/Address/ExistsCity' + params,
        method: 'get',
      });
    },
    // 查询三级地区是否存在
    judgeExistsArea(params) {
      // 拼接参数： id 编号（int）  code 县区代码（string）
      return request({
        url: '/Address/ExistsArea' + params,
        method: 'get',
      });
    },
    //添加、修改一级地区（省）
    setProvince(params) {
      // 对象DTO： 省名称 Name（str）、省代码 Code（str）、省 Id(int)
      return request({
        url: '/Address/SetProvinces',
        method: 'post',
        data: params
      });
    },
    //添加、修改二级地区（市）
    setCity(params) {
      // 对象DTO： 省代码 ProvincesId（str）、市名称 Name（str）、市代码 Code（str）、市 Id(int)
      return request({
        url: '/Address/SetCity',
        method: 'post',
        data: params
      });
    },
    //添加、修改三级地区（县区）
    setArea(params) {
      // 对象DTO： 市代码 CityId（str）、区名称 Name（str）、区代码 Code（str）、区 Id(int)
      return request({
        url: '/Address/SetArea',
        method: 'post',
        data: params
      });
    },
    //删除一级地区（省）
    removeProvince(params) {
      // 拼接参数：一级地区 id（int）
      return request({
        url: '/Address/RemoveProvinces'+ params,
        method: 'post',
      });
    },
    //删除二级地区（市）
    removeCity(params) {
      // 拼接参数：二级地区 id（int）
      return request({
        url: '/Address/RemoveCity'+ params,
        method: 'post',
      });
    },
    //删除三级地区（县区）
    removeArea(params) {
      // 拼接参数：三级地区 id（int）
      return request({
        url: '/Address/RemoveArea'+ params,
        method: 'post',
      });
    },
}
